export default "__VITE_ASSET__BR4ZqZBy__"